/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportFull,
  ReportFullOptional,
  ReportFullMetaI,
  ReportFullTrackedI,
} from "./report-full";
import { ReportFullTracked, ReportFullMeta } from "./report-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportMetaDTO,
  ReportMetaDTOOptional,
  ReportMetaDTOMetaI,
  ReportMetaDTOTrackedI,
} from "./report-meta-dto";
import { ReportMetaDTOTracked, ReportMetaDTOMeta } from "./report-meta-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportStatus,
  ReportStatusOptional,
  ReportStatusMetaI,
  ReportStatusTrackedI,
} from "./report-status";
import { ReportStatusTracked, ReportStatusMeta } from "./report-status";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportType,
  ReportTypeOptional,
  ReportTypeMetaI,
  ReportTypeTrackedI,
} from "./report-type";
import { ReportTypeTracked, ReportTypeMeta } from "./report-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportTypeCountDTO,
  ReportTypeCountDTOOptional,
  ReportTypeCountDTOMetaI,
  ReportTypeCountDTOTrackedI,
} from "./report-type-count-dto";
import {
  ReportTypeCountDTOTracked,
  ReportTypeCountDTOMeta,
} from "./report-type-count-dto";

/**
 *
 * @export
 * @interface ReportDTO
 */
export interface ReportDTOOptional extends ReportFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof ReportDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ReportDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof ReportDTO
   */
  reportId?: number;
  /**
   *
   * @type {string}
   * @memberof ReportDTO
   */
  reportKey?: string;
  /**
   *
   * @type {string}
   * @memberof ReportDTO
   */
  reportTitle?: string;
  /**
   *
   * @type {ReportType}
   * @memberof ReportDTO
   */
  reportType?: ReportType;
  /**
   *
   * @type {ReportStatus}
   * @memberof ReportDTO
   */
  reportStatus?: ReportStatus;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof ReportDTO
   */
  childReports?: ReportDTOOptional[];
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof ReportDTO
   */
  meta?: ReportMetaDTOOptional[];
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof ReportDTO
   */
  typeCounts?: ReportTypeCountDTOOptional[];
}

export interface ReportDTO extends ReportDTOOptional, ReportFull {
  /**
   *
   * @type {boolean}
   * @memberof ReportDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ReportDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof ReportDTO
   */
  reportId: number;
  /**
   *
   * @type {string}
   * @memberof ReportDTO
   */
  reportKey: string;
  /**
   *
   * @type {string}
   * @memberof ReportDTO
   */
  reportTitle?: string;
  /**
   *
   * @type {ReportType}
   * @memberof ReportDTO
   */
  reportType?: ReportType;
  /**
   *
   * @type {ReportStatus}
   * @memberof ReportDTO
   */
  reportStatus?: ReportStatus;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof ReportDTO
   */
  childReports?: ReportDTO[];
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof ReportDTO
   */
  meta?: ReportMetaDTO[];
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof ReportDTO
   */
  typeCounts?: ReportTypeCountDTO[];
}

export interface ReportDTOTrackedI extends ReportFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof ReportDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ReportDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ReportDTO
   */
  reportId?: number;
  reportIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ReportDTO
   */
  reportKey?: string;
  reportKeyIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ReportDTO
   */
  reportTitle?: string;
  reportTitleIsSet: boolean;
  /**
   *
   * @type {ReportType}
   * @memberof ReportDTO
   */
  reportType?: ReportType;
  reportTypeIsSet: boolean;
  /**
   *
   * @type {ReportStatus}
   * @memberof ReportDTO
   */
  reportStatus?: ReportStatus;
  reportStatusIsSet: boolean;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof ReportDTO
   */
  childReports?: ReportDTOTrackedI[];
  childReportsIsSet: boolean;
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof ReportDTO
   */
  meta?: ReportMetaDTOTrackedI[];
  metaIsSet: boolean;
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof ReportDTO
   */
  typeCounts?: ReportTypeCountDTOTrackedI[];
  typeCountsIsSet: boolean;
}

transformDatesMap.set("ReportDTO", function (model: ReportDTO) {
  const transformDateschildReports = transformDatesMap.get("ReportDTO");
  if (transformDateschildReports) {
    model.childReports?.forEach((sub) => {
      transformDateschildReports(sub);
    });
  }
  const transformDatesmeta = transformDatesMap.get("ReportMetaDTO");
  if (transformDatesmeta) {
    model.meta?.forEach((sub) => {
      transformDatesmeta(sub);
    });
  }
  const transformDatestypeCounts = transformDatesMap.get("ReportTypeCountDTO");
  if (transformDatestypeCounts) {
    model.typeCounts?.forEach((sub) => {
      transformDatestypeCounts(sub);
    });
  }
});

export type ReportDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  reportId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  reportKey: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reportTitle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reportType: PropertyMeta<ReportTypeMetaI>;
  //isDate: false
  //isDatetime: false
  reportStatus: PropertyMeta<ReportStatusMetaI>;
  //isDate: false
  //isDatetime: false
  childReports: PropertyMeta<ReportDTOMetaI>;
  //isDate: false
  //isDatetime: false
  meta: PropertyMeta<ReportMetaDTOMetaI>;
  //isDate: false
  //isDatetime: false
  typeCounts: PropertyMeta<ReportTypeCountDTOMetaI>;
}>;

export var ReportDTOMeta: ReportDTOMetaI = {} as ReportDTOMetaI;
ReportDTOMeta = typeMeta("ReportDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  reportId: propertyMeta("reportId", false, true, true, MetaTypesBase.number),
  reportKey: propertyMeta(
    "reportKey",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  reportTitle: propertyMeta(
    "reportTitle",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  reportType: propertyMeta("reportType", false, false, false, ReportTypeMeta),
  reportStatus: propertyMeta(
    "reportStatus",
    false,
    false,
    false,
    ReportStatusMeta,
  ),
  childReports: propertyMeta("childReports", true, false, false, ReportDTOMeta),
  meta: propertyMeta("meta", true, false, false, ReportMetaDTOMeta),
  typeCounts: propertyMeta(
    "typeCounts",
    true,
    false,
    false,
    ReportTypeCountDTOMeta,
  ),
});

const metaI = ReportDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([ReportFullMeta]);
  metaI.isDeleted.inheritedFrom = ReportFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = ReportFullMeta.isNew;
  metaI.reportId.inheritedFrom = ReportFullMeta.reportId;
  metaI.reportKey.inheritedFrom = ReportFullMeta.reportKey;
  metaI.reportTitle.inheritedFrom = ReportFullMeta.reportTitle;
  metaI.reportType.inheritedFrom = ReportFullMeta.reportType;
  metaI.reportStatus.inheritedFrom = ReportFullMeta.reportStatus;
  metaI.childReports.inheritedFrom = ReportFullMeta.childReports;
  metaI.meta.inheritedFrom = ReportFullMeta.meta;
});

export class ReportDTOTracked
  extends ReportFullTracked
  implements ReportDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  reportId__I?: number = undefined;

  get reportIdIsSet() {
    return this.reportId !== undefined;
  }
  set reportIdIsSet(v: boolean) {}
  set reportId(v: undefined | number) {
    if (v !== undefined) {
      this.reportId__I = v;
      this.reportIdIsSet = true;
    } else {
      this.reportId__I = v || undefined;
      this.reportIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get reportId() {
    return this.reportId__I;
  }
  reportKey__I?: string = undefined;
  reportKeyIsSet: boolean = false;
  set reportKey(v: undefined | string) {
    if (v !== undefined) {
      this.reportKey__I = v;
      this.reportKeyIsSet = true;
    } else {
      this.reportKey__I = v || undefined;
      this.reportKeyIsSet = true;
    }
    this.changeTracker = true;
  }
  get reportKey() {
    return this.reportKey__I;
  }
  reportTitle__I?: string = undefined;
  reportTitleIsSet: boolean = false;
  set reportTitle(v: undefined | string) {
    if (v !== undefined) {
      this.reportTitle__I = v;
      this.reportTitleIsSet = true;
    } else {
      this.reportTitle__I = v || undefined;
      this.reportTitleIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportTitle() {
    return this.reportTitle__I;
  }
  reportType__I?: ReportType = undefined;
  reportTypeIsSet: boolean = false;
  set reportType(v: undefined | ReportType) {
    if (v !== undefined) {
      this.reportType__I = v;
      this.reportTypeIsSet = true;
    } else {
      this.reportType__I = v || undefined;
      this.reportTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportType() {
    return this.reportType__I;
  }
  reportStatus__I?: ReportStatus = undefined;
  reportStatusIsSet: boolean = false;
  set reportStatus(v: undefined | ReportStatus) {
    if (v !== undefined) {
      this.reportStatus__I = v;
      this.reportStatusIsSet = true;
    } else {
      this.reportStatus__I = v || undefined;
      this.reportStatusIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportStatus() {
    return this.reportStatus__I;
  }
  childReports__I?: ReportDTOTracked[] = undefined;
  childReportsIsSet: boolean = false;
  set childReports(v: undefined | ReportDTOTracked[]) {
    if (v !== undefined) {
      this.childReports__I = v;
      this.childReportsIsSet = true;
    } else {
      this.childReports__I = v || undefined;
      this.childReportsIsSet = false;
    }
    this.changeTracker = true;
  }
  get childReports() {
    return this.childReports__I;
  }
  meta__I?: ReportMetaDTOTracked[] = undefined;
  metaIsSet: boolean = false;
  set meta(v: undefined | ReportMetaDTOTracked[]) {
    if (v !== undefined) {
      this.meta__I = v;
      this.metaIsSet = true;
    } else {
      this.meta__I = v || undefined;
      this.metaIsSet = false;
    }
    this.changeTracker = true;
  }
  get meta() {
    return this.meta__I;
  }
  typeCounts__I?: ReportTypeCountDTOTracked[] = undefined;
  typeCountsIsSet: boolean = false;
  set typeCounts(v: undefined | ReportTypeCountDTOTracked[]) {
    if (v !== undefined) {
      this.typeCounts__I = v;
      this.typeCountsIsSet = true;
    } else {
      this.typeCounts__I = v || undefined;
      this.typeCountsIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeCounts() {
    return this.typeCounts__I;
  }
  constructor(config?: ReportDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.reportIdIsSet == true && other?.reportIdIsSet == true)
      return this.reportId == other.reportId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.reportId) {
      this.reportIdIsSet = true;
    }

    this.childReports?.forEach((a) => a.setIds());

    this.meta?.forEach((a) => a.setIds());

    this.typeCounts?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: ReportDTOOptional,
    options?: AssignOptions,
  ): ReportDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.reportId && this.reportIdApplyFilter(optionsRequired.filter)) {
      this.reportId = config.reportId;
      if (optionsRequired.unassign) this.reportIdIsSet = false;
      else this.reportIdIsSet = true;
    }
    if (config.reportKey && this.reportKeyApplyFilter(optionsRequired.filter)) {
      this.reportKey = config.reportKey;
      if (optionsRequired.unassign) this.reportKeyIsSet = false;
      else this.reportKeyIsSet = true;
    }
    if (
      config.reportTitle &&
      this.reportTitleApplyFilter(optionsRequired.filter)
    ) {
      this.reportTitle = config.reportTitle;
      if (optionsRequired.unassign) this.reportTitleIsSet = false;
      else this.reportTitleIsSet = true;
    }
    if (
      config.reportType &&
      this.reportTypeApplyFilter(optionsRequired.filter)
    ) {
      this.reportType = config.reportType;
      if (optionsRequired.unassign) this.reportTypeIsSet = false;
      else this.reportTypeIsSet = true;
    }
    if (
      config.reportStatus &&
      this.reportStatusApplyFilter(optionsRequired.filter)
    ) {
      this.reportStatus = config.reportStatus;
      if (optionsRequired.unassign) this.reportStatusIsSet = false;
      else this.reportStatusIsSet = true;
    }
    if (
      config.childReports &&
      this.childReportsApplyFilter(optionsRequired.filter)
    ) {
      this.childReports = config.childReports?.map(
        (a) => new ReportDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.childReportsIsSet = false;
      else this.childReportsIsSet = true;
    }
    if (config.meta && this.metaApplyFilter(optionsRequired.filter)) {
      this.meta = config.meta?.map((a) => new ReportMetaDTOTracked(a, options));
      if (optionsRequired.unassign) this.metaIsSet = false;
      else this.metaIsSet = true;
    }
    if (
      config.typeCounts &&
      this.typeCountsApplyFilter(optionsRequired.filter)
    ) {
      this.typeCounts = config.typeCounts?.map(
        (a) => new ReportTypeCountDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.typeCountsIsSet = false;
      else this.typeCountsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ReportDTOTrackedI {
    const cloned = {} as ReportDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.reportIdIsSetDeep() &&
      this.reportIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportIdIsSet = true;
      cloned.reportId = this.reportId;
    } else {
      //cloned.reportIdIsSet = false
    }
    if (
      this.reportKeyIsSetDeep() &&
      this.reportKeyApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportKeyIsSet = true;
      cloned.reportKey = this.reportKey;
    } else {
      //cloned.reportKeyIsSet = false
    }
    if (
      this.reportTitleIsSetDeep() &&
      this.reportTitleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportTitleIsSet = true;
      cloned.reportTitle = this.reportTitle;
    } else {
      //cloned.reportTitleIsSet = false
    }
    if (
      this.reportTypeIsSetDeep() &&
      this.reportTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportTypeIsSet = true;
      cloned.reportType = this.reportType;
    } else {
      //cloned.reportTypeIsSet = false
    }
    if (
      this.reportStatusIsSetDeep() &&
      this.reportStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportStatusIsSet = true;
      cloned.reportStatus = this.reportStatus;
    } else {
      //cloned.reportStatusIsSet = false
    }
    if (
      this.childReportsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.childReportsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.childReportsIsSet = true;
      cloned.childReports = this.childReports
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.childReportsIsSet = false
    }
    if (
      this.metaIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.metaApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.metaIsSet = true;
      cloned.meta = this.meta
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.metaIsSet = false
    }
    if (
      this.typeCountsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.typeCountsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeCountsIsSet = true;
      cloned.typeCounts = this.typeCounts
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.typeCountsIsSet = false
    }
    if (!isDeleted(this) && !this.reportIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ReportDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.reportIdApplyFilter(filter)) this.reportIdIsSet = false;

    if (!this.reportKeyApplyFilter(filter)) this.reportKeyIsSet = false;

    if (!this.reportTitleApplyFilter(filter)) this.reportTitleIsSet = false;

    if (!this.reportTypeApplyFilter(filter)) this.reportTypeIsSet = false;

    if (!this.reportStatusApplyFilter(filter)) this.reportStatusIsSet = false;

    if (!this.childReportsApplyFilter(filter)) this.childReportsIsSet = false;

    this.childReports?.forEach((a) => a.unassignAll(filter));
    if (!this.metaApplyFilter(filter)) this.metaIsSet = false;

    this.meta?.forEach((a) => a.unassignAll(filter));
    if (!this.typeCountsApplyFilter(filter)) this.typeCountsIsSet = false;

    this.typeCounts?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(ReportDTOMeta.isDeleted, ReportDTOMeta, this.isDeleted, this);
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(ReportDTOMeta.isNew, ReportDTOMeta, this.isNew, this);
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  reportIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(ReportDTOMeta.reportId, ReportDTOMeta, this.reportId, this);
  }
  reportIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportIdIsSet && this.reportIdApplyFilter(filter)) return true;

    return false;
  }
  reportKeyApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(ReportDTOMeta.reportKey, ReportDTOMeta, this.reportKey, this);
  }
  reportKeyIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportKeyIsSet && this.reportKeyApplyFilter(filter)) return true;

    return false;
  }
  reportTitleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ReportDTOMeta.reportTitle,
      ReportDTOMeta,
      this.reportTitle,
      this,
    );
  }
  reportTitleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportTitleIsSet && this.reportTitleApplyFilter(filter))
      return true;

    return false;
  }
  reportTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ReportDTOMeta.reportType,
      ReportDTOMeta,
      this.reportType,
      this,
    );
  }
  reportTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportTypeIsSet && this.reportTypeApplyFilter(filter)) return true;

    return false;
  }
  reportStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ReportDTOMeta.reportStatus,
      ReportDTOMeta,
      this.reportStatus,
      this,
    );
  }
  reportStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportStatusIsSet && this.reportStatusApplyFilter(filter))
      return true;

    return false;
  }
  childReportsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ReportDTOMeta.childReports,
      ReportDTOMeta,
      this.childReports,
      this,
    );
  }
  childReportsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.childReportsIsSet && this.childReportsApplyFilter(filter))
      return true;

    return this.childReports?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  metaApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(ReportDTOMeta.meta, ReportDTOMeta, this.meta, this);
  }
  metaIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.metaIsSet && this.metaApplyFilter(filter)) return true;

    return this.meta?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  typeCountsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ReportDTOMeta.typeCounts,
      ReportDTOMeta,
      this.typeCounts,
      this,
    );
  }
  typeCountsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeCountsIsSet && this.typeCountsApplyFilter(filter)) return true;

    return this.typeCounts?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.reportIdIsSetDeep(filter)) return true;
    if (this.reportKeyIsSetDeep(filter)) return true;
    if (this.reportTitleIsSetDeep(filter)) return true;
    if (this.reportTypeIsSetDeep(filter)) return true;
    if (this.reportStatusIsSetDeep(filter)) return true;
    if (this.childReportsIsSetDeep(filter)) return true;
    if (this.metaIsSetDeep(filter)) return true;
    if (this.typeCountsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
